import { render, staticRenderFns } from "./AssigneeForm.vue?vue&type=template&id=201ec528"
import script from "./AssigneeForm.vue?vue&type=script&lang=js"
export * from "./AssigneeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports